<template>
  <b-container fluid>
    <loader :watch="['guard1000']">
      <div class="form-view col-xl-8">
        <b-alert v-if="!!error" variant="danger">{{ error }}</b-alert>
        <h2 class="mq">Edit</h2>
        <b-form lazy-validation novalidate @submit.prevent="submit">
          <b-form-group label="Name">
            <b-form-input v-model="guard1000Form.name" />
          </b-form-group>
          <b-form-group class="form-group__buttons">
            <router-link
              :to="{
                name: 'substationDevices',
                params: {
                  projectCode: $route.params.projectCode,
                  substationCode: $route.params.substationCode
                }
              }"
              class="btn btn-link font-weight-bold"
            >
              Cancel
            </router-link>
            <b-button type="submit" :disabled="isDisabled" variant="rounded" @submit="submit">
              Save
              <Icon name="save" />
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </loader>
  </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'EditGuard1000',
  data() {
    return {
      guard1000Form: {
        name: ''
      }
    };
  },
  computed: {
    ...mapState({
      error: state => state.guard1000.error,
      guard1000: state => state.guard1000.data
    }),
    isDisabled() {
      return !this.guard1000Form.name.length || this.guard1000Form.name === this.guard1000.name;
    }
  },
  async mounted() {
    const { projectCode, substationCode, externalGuardId } = this.$route.params;

    await this.fetchGuard1000({ projectCode, substationCode, externalGuardId });

    this.guard1000Form = { ...this.guard1000 };
  },
  methods: {
    ...mapActions({
      fetchGuard1000: 'guard1000/fetchGuard1000',
      updateGuard: 'guard1000/editGuard1000'
    }),
    async submit() {
      const { projectCode, substationCode, externalGuardId } = this.$route.params;

      await this.updateGuard({
        projectCode,
        substationCode,
        externalGuardId,
        data: { name: this.guard1000Form.name }
      });

      if (!this.error) {
        return this.$router.push({
          name: 'substationDevices',
          params: {
            projectCode: this.$route.params.projectCode,
            substationCode: this.$route.params.substationCode
          }
        });
      }
    }
  }
};
</script>
